import UsersAssigned from './UsersAssigned';

export default UsersAssigned;
